// src/components/PostNavigation.jsx
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Nav = styled.nav`
  background: var(--card);
  border-top: 1px solid var(--bdr);
  border-bottom: 1px solid var(--bdr);
  padding: 24px 0;
`;

const Container = styled.div`
  width: min(800px, 92vw);
  margin: 0 auto;
  padding: 0 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 0 16px;
  }
`;

const NavLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: var(--bg);
  border: 1px solid var(--bdr);
  border-radius: 12px;
  text-decoration: none;
  color: inherit;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow);
    border-color: var(--primary);
  }
  
  &.next {
    justify-content: flex-end;
    text-align: right;
  }
  
  @media (max-width: 768px) {
    &.next {
      justify-content: flex-start;
      text-align: left;
    }
  }
`;

const NavContent = styled.div`
  flex: 1;
`;

const NavLabel = styled.div`
  font-size: 12px;
  color: var(--muted);
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 4px;
`;

const NavTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: var(--fg);
  line-height: 1.3;
  
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const NavIcon = styled.div`
  font-size: 20px;
  color: var(--primary);
  flex-shrink: 0;
`;

const Placeholder = styled.div`
  /* Пустое место для выравнивания, когда есть только одна ссылка */
`;

export default function PostNavigation({ prevPost, nextPost }) {
  const { t } = useTranslation();
  
  if (!prevPost && !nextPost) return null;
  
  return (
    <Nav>
      <Container>
        {prevPost ? (
          <NavLink to={`/blog/${prevPost.slug}`} className="prev">
            <NavIcon>←</NavIcon>
            <NavContent>
              <NavLabel>{t('blogPost.navigation.prev', 'Предыдущая статья')}</NavLabel>
              <NavTitle>{prevPost.title}</NavTitle>
            </NavContent>
          </NavLink>
        ) : (
          <Placeholder />
        )}
        
        {nextPost ? (
          <NavLink to={`/blog/${nextPost.slug}`} className="next">
            <NavContent>
              <NavLabel>{t('blogPost.navigation.next', 'Следующая статья')}</NavLabel>
              <NavTitle>{nextPost.title}</NavTitle>
            </NavContent>
            <NavIcon>→</NavIcon>
          </NavLink>
        ) : (
          <Placeholder />
        )}
      </Container>
    </Nav>
  );
}